<template>
<div class="button-wrap">
    <div class="next"  :class="{mb: mb, has: has, cover: cover}" @click="next()">{{ txt }}</div>
</div>
</template>
<script>

export default {
    name: 'buttonwrap',
    props: {
        mb: { type: String, default: '' },
        has: { type: Boolean, default: false },
        cover: { type: Boolean, default: false },
        txt: { type: String, default: '' }
    },
    data() {
        return {
        };
    },
    components: {
    },
    methods: {
        next() {
            this.$emit('btnSure');
        }
    },

    beforeMount() {
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.button-wrap {
    .next {
        display: block;
        position: relative;
        margin-top: 40px;
        width:100%;
        height:48px;
        background:rgba(224,224,224,1);
        border-radius:24px;
        font-size:16px;
        font-family: 'RobotoMedium';
        font-weight:500;
        text-align: center;
        color:rgba(171,171,171,1);
        line-height:48px;
        cursor: pointer;
        transition: background linear .1s;
        &.mb {
            margin-top: rem(40);
            height: rem(48);
            border-radius: rem(24);
            line-height: rem(48);
        }
        &.has {
            background-image: linear-gradient(#9d1dff, #9d1dff);
            color:rgba(255,255,255,1);
        }
        &.cover {
            background-blend-mode: multiply;
            background-color: rgba(0, 0, 0, 0.2);
        }
    }
}
</style>
